import { render, staticRenderFns } from "./ShowCustomerDetails.vue?vue&type=template&id=4e409172&"
import script from "./ShowCustomerDetails.vue?vue&type=script&lang=js&"
export * from "./ShowCustomerDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports